'use strict';

/**
 * Directive that moves input cursor to the end of the text when it's focused for the first time.
 */
export default ($timeout) => {
  'ngInject';

  return {
    restrict: 'A',
    link: ($scope, $element) => {
      const element = $element[0];

      $element.one('focus', () => {
        const caretPosition = element.value.length;

        $timeout(() => {
          if (element.createTextRange) {
            const range = element();
            range.move('character', caretPosition);
            range.select();
          } else if (element.setSelectionRange) {
            element.setSelectionRange(caretPosition, caretPosition);
          }
        });
      });
    }
  };
};



// WEBPACK FOOTER //
// ./app/src/directives/cursor.js